import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { withDefaults } from '../../utils/withDefaults'
import { spreadTypography } from '../../utils/typeUtils'

const LinkButtonRoot = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'center',
})<{ center?: boolean }>(({ theme, center }) => ({
  ...spreadTypography(theme.typography['Lato Link 2']),

  ...(center && { margin: 'auto' }),
}))

export const LinkButton = withDefaults(LinkButtonRoot, {
  variant: 'borderless',
  type: 'button',
})